import script from "./MobileMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileMenu.vue?vue&type=script&setup=true&lang=js"

import "./MobileMenu.vue?vue&type=style&index=0&id=46af24fc&lang=less&scoped=true"

import exportComponent from "/Users/beiyu/Documents/web/森瑶/web/senyao-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46af24fc"]])

export default __exports__